export default class ServicesLink {
	constructor(element) {
	  this.link = element;
	  this.parentItem = this.link.closest('.services__item'); // Zoek de parent met de class 'services__item'
	  this.introItems = document.querySelectorAll('.service__item-intro');
	  this.link.addEventListener('mouseover', this.handleMouseOver.bind(this));
	  this.link.addEventListener('mouseout', this.handleMouseOut.bind(this));
	}

	handleMouseOver() {
	  if (window.innerWidth >= 900) {
		 this.parentItem.classList.add('active-2'); // Voeg de class 'active.2' toe aan de parent
		 this.introItems.forEach(intro => {
			intro.classList.remove('active');
		 });
	  }
	}

	handleMouseOut() {
	  if (window.innerWidth >= 900) {
		 this.parentItem.classList.remove('active-2'); // Verwijder de class 'active.2' van de parent
		 this.introItems.forEach(intro => {
			intro.classList.add('active');
		 });
	  }
	}
 }
